import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/es/integration/react'
import { store, persistor } from './config/redux'
import 'typeface-asap-condensed'
import 'typeface-asap'
import { BrowserRouter as Router } from 'react-router-dom'
import './utils/devTools'

const search = window.location.search
const code = search.includes('?code=') ? search.replace('?code=', '').split('&')[0] : ''

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        <App code={code} />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// CRA service worker not used — push notification service worker is registered
// separately in webPushService.ts via subscribeToPush()
